import React, {useState, useEffect, useRef} from 'react';
import http from '../../api/http';
import Editor from '../../components/CKEditor/editor';
import {timeAgo} from '../../components/layouts/mainLayout/HeaderRight';

interface ConfigData {
    data?: {
        activeEmails?: string;
        items?: Array<{
            _id?: number;
            activeEmails?: string[];
            status?: string;
            createdAt?: string;
            updatedAt?: string;
            cd?: string;
            __v?: number;
        }>;
    };
}

interface Props {
    configData?: ConfigData;
    handleConfigChange: (key: string, value: string) => void;
    handleUpdateConfig: () => void;
}

let curEmail = ''
const AdminConfigPage = () => {
    const [configData, setConfigData] = useState({data: {}});
    const [disabled, setDisabled] = useState(false);

    let fields = [
        {
            name: 'Your results Interpretation',
            key: 'your_results_interpretaion'
        },
        {
            name: 'According to the results of your blood test, there is evidence of a potential inflammatory process in your body, which may be attributed to the following factors:',
            key: 'found_interpreations'
        },
        {
            name: 'Recommendations and next steps',
            key: 'recommendations_and_next_steps'
        },
        {
            name: 'According to the results of your blood test you need to add biomarkers to get informative results',
            key: 'empty_to_add_biomarkers'
        },
        {
            name: 'Insert Biomarkers',
            key: 'insert_biomarkers'
        },
        {
            name: 'Add Biomarker Button',
            key: 'add_biomarker_button'
        }, {
            name: 'Your Personalized Health Evaluation Report',
            key: 'your_personalized'
        },
        {
            name: 'Hollistic Health Status',
            key: 'holistic_health_status'
        }, {
            name: 'We are unable to display your results at this moment. To obtain a detailed analysis, please add or input the necessary biomarkers.',
            key: 'we_are_enable'
        },
        {
            name: 'Disclaimer',
            key: 'footer_name'
        }
        , {
            name: 'Disclaimer: Based on data collected from our users in November 2022. All data collected with consent from our users. ​The information XY provides is for educational and informational use only. The information is not intended to be used by the customer for any diagnostic purpose and is not a substitute for professional medical advice. You should always seek the advice of your physician or other healthcare providers with any questions you may have regarding diagnosis, cure, treatment, mitigation, or prevention of any disease or other medical condition or impairment or the status of your health',
            key: 'footer'
        }, {
            name: `Based on your blood test results, your overall health status requires attention and improvement. Our analysis focuses on seven key health systems that contribute to your well-being and performance:`,
            key: 'overall_text'
        }
        , {
            name: `Copyright © 2023 LLC "SMRTLIFE"`,
            key: 'copyright'
        }]


    useEffect(() => {
        http.get('/api/core/config')
            .then(response => {
                console.log('Config loaded from server:', response.data);
                const activeEmails = response?.data?.data?.items?.[0]?.activeEmails || response?.data?.data?.[0]?.activeEmails || response?.data?.data?.activeEmails || '';
                console.log('Active emails from server:', activeEmails);
                curEmail = Array.isArray(activeEmails) ? activeEmails.join('\n') : activeEmails;
                console.log('Processed curEmail:', curEmail);
                setConfigData(response.data);
            })
            .catch(error => {
                console.error('Failed to fetch config:', error);
            });
    }, []);

    let dd: any = (configData || {}).data || {}
    // Если dd — массив, работаем с первым элементом
    const getField = (key: string) => {
        if (dd?.items && Array.isArray(dd.items) && dd.items.length > 0) {
            const result = dd.items[0]?.[key];
            console.log(`getField('${key}') - new structure with items - result:`, result);
            return result;
        }
        const result = Array.isArray(dd) ? dd[0]?.[key] : dd?.[key];
        console.log(`getField('${key}') - old structure - dd:`, dd, 'isArray:', Array.isArray(dd), 'result:', result);
        return result;
    };
    const setField = (key: string, value: any) => {
        if (configData.data && 'items' in configData.data && configData.data.items && Array.isArray(configData.data.items)) {
            const newItems = [...configData.data.items];
            if (newItems.length > 0) {
                newItems[0] = { ...newItems[0], [key]: value };
                setConfigData({ ...configData, data: { ...configData.data, items: newItems } });
            }
        } else if (Array.isArray(configData.data)) {
            const newArr = [...configData.data];
            newArr[0] = { ...newArr[0], [key]: value };
            setConfigData({ ...configData, data: newArr });
        } else {
            setConfigData({ ...configData, data: { ...(configData.data || {}), [key]: value } });
        }
    };

    const handleConfigChange = (key: any, value: any, isReset?: boolean) => {
        setField(key, value);
    };
    
    console.log('dd', dd);

    // Локальный стейт для поля activeEmails
    const [activeEmailsInput, setActiveEmailsInput] = useState(() => {
        const val = getField('activeEmails') || '';
        if (Array.isArray(val)) {
            return val.join('\n');
        }
        return typeof val === 'string' ? val : '';
    });

    useEffect(() => {
        const val = getField('activeEmails') || '';
        console.log('useEffect for activeEmailsInput - val:', val, 'type:', typeof val, 'isArray:', Array.isArray(val));
        if (Array.isArray(val)) {
            const joined = val.join('\n');
            console.log('Setting activeEmailsInput to joined array:', joined);
            setActiveEmailsInput(joined);
        } else if (typeof val === 'string') {
            console.log('Setting activeEmailsInput to string:', val);
            setActiveEmailsInput(val);
        } else {
            console.log('Setting activeEmailsInput to empty string');
            setActiveEmailsInput('');
        }
    }, [configData]);

    // useEffect(() => {
    //     let d2 = (configData || {}) as any;
    //     d2?._id && curEmail !== dd?.activeEmails && handleUpdateConfig();
    //     (global as any)?.updateEditor && (global as any)?.updateEditor(dd?.activeEmails)
    //     curEmail = dd?.activeEmails;
    // }, [dd?.activeEmails])

    const handleUpdateConfig = () => {
        setDisabled(true);
        const emailsArray = (activeEmailsInput || '')
            .split(/\s*[\n,]+\s*/)
            .map(e => e.trim())
            .filter(e => e);

        http.post('/api/core/config/update', { emails: emailsArray })
            .then(() => {
                setTimeout(() => setDisabled(false), 500);
                console.log('Config updated successfully');
                // Перезагружаем данные с сервера после успешного обновления
                http.get('/api/core/config')
                    .then(response => {
                        console.log('Config reloaded after update:', response.data);
                        const activeEmails = response?.data?.data?.items?.[0]?.activeEmails || response?.data?.data?.[0]?.activeEmails || response?.data?.data?.activeEmails || '';
                        console.log('Active emails after reload:', activeEmails);
                        curEmail = Array.isArray(activeEmails) ? activeEmails.join('\n') : activeEmails;
                        console.log('Processed curEmail after reload:', curEmail);
                        setConfigData(response.data);
                    })
                    .catch(error => {
                        console.error('Failed to reload config:', error);
                    });
            })
            .catch(error => {
                console.error('Failed to update config:', error);
                setDisabled(false);
            });
    };

    const handleSaveAllConfig = () => {
        setDisabled(true);
        const emailsArray = (activeEmailsInput || '')
            .split(/\s*[\n,]+\s*/)
            .map(e => e.trim())
            .filter(e => e);

        http.post('/api/core/config/update', { emails: emailsArray })
            .then(() => {
                setTimeout(() => setDisabled(false), 500);
                console.log('All config updated successfully');
                // Перезагружаем данные с сервера после успешного обновления
                http.get('/api/core/config')
                    .then(response => {
                        console.log('Config reloaded after save all:', response.data);
                        const activeEmails = response?.data?.data?.items?.[0]?.activeEmails || response?.data?.data?.[0]?.activeEmails || response?.data?.data?.activeEmails || '';
                        console.log('Active emails after save all reload:', activeEmails);
                        curEmail = Array.isArray(activeEmails) ? activeEmails.join('\n') : activeEmails;
                        console.log('Processed curEmail after save all reload:', curEmail);
                        setConfigData(response.data);
                    })
                    .catch(error => {
                        console.error('Failed to reload config:', error);
                    });
            })
            .catch(error => {
                console.error('Failed to update all config:', error);
                setDisabled(false);
            });
    };
    let btn = useRef<HTMLButtonElement>(null);
    let isEditor = (global as any)?.isEditor;

    console.log("qqqqq configdata", configData?.data);
    return (
        <div className="admin-config">

            <div className={'w100 config-item'}>
                <small>Active Editor Emails (other logins will be in view mode only)</small>
                <textarea
                    // disabled={!isEditor}
                    className={'w100'}
                    style={{display: 'block', maxWidth: '100%'}}
                    value={activeEmailsInput}
                    onChange={(e: any) => {
                        setActiveEmailsInput(e.target.value);
                        handleConfigChange('activeEmails', e.target.value)
                    }}
                ></textarea>
                <div className="tr">
                    <button className={'btn'} onClick={() => {
                        let emailsList = `natascha.imhof@smrtlife.ch\nn.imhof17@gmail.com`;
                        setActiveEmailsInput(emailsList);
                        handleConfigChange('activeEmails', emailsList);
                        (global as any)?.updateEditor && (global as any)?.updateEditor(emailsList)

                        setTimeout(() => {
                            btn.current?.click()
                        }, 500)

                    }}>Reset to default active list
                    </button>
                    <button
                        ref={btn}
                        id={'updateConfig'}
                        // disabled={!isEditor}
                        className={'btn'} onClick={() => {
                        handleUpdateConfig();
                        (global as any)?.updateEditor && (global as any)?.updateEditor(activeEmailsInput)
                    }}>Update List
                    </button>
                </div>
                <hr/>
            </div>
            {/* Новый блок приглашения админов */}
            <div className={'w100 config-item'} style={{marginTop: 30, border: '1px solid #eee', borderRadius: 8, padding: 16}}>
                <h4>Invite Admin User</h4>
                <InviteAdminForm />
            </div>
            {/*Is Force Editor <input type="checkbox" value={!isEditor as boolean}*/}
            {/*                onChange={(v) => {*/}
            {/*                    (global as any)?.setForceEditor()*/}
            {/*                }}/>*/}
            {fields.map((d: any, index) => {
                let {key, name} = d || {};
                return <div key={index} className="config-item"
                            style={{marginTop: '20px', borderBottom: '1px solid lightgrey'}}>
                    <small>{name}</small>
                    <div></div>
                    <Editor
                        placeholder={'Your value ...'}
                        value={getField(key) || ''}
                        onChange={(e: any) => handleConfigChange(key, e)}
                    />
                </div>
            })}

            <div style={{marginTop: "20px"}}>
                <button className='btn' disabled={disabled} onClick={() => {
                    handleSaveAllConfig()
                }}>Save Config
                </button>
                <div className={'paddTs'}>
                    {/* <hr/> */}
                    Last update: {getField('lastUpdate') ? timeAgo(getField('lastUpdate')) : ''}
                </div>
            </div>

        </div>
    );
}

// Форма приглашения админа
const InviteAdminForm = () => {
    const [email, setEmail] = useState('');
    const [firstName, setFirstName] = useState('');
    const [lastName, setLastName] = useState('');
    const [role, setRole] = useState('admin');
    const [department, setDepartment] = useState('');
    const [loading, setLoading] = useState(false);
    const [result, setResult] = useState<{success: boolean, message: string, error?: string} | null>(null);

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setResult(null);
        if (!email) {
            setResult({success: false, message: 'Email is required'});
            return;
        }
        setLoading(true);
        try {
            const res = await http.post('/api/admins/invite', {
                email,
                firstName: firstName || undefined,
                lastName: lastName || undefined,
                role,
                department: department || undefined
            });
            setResult({success: true, message: 'Invitation sent successfully'});
            setEmail(''); setFirstName(''); setLastName(''); setDepartment('');
        } catch (err: any) {
            let msg = err?.response?.data?.message || err?.message || 'Unknown error';
            let errorDetail = err?.response?.data?.error;
            setResult({success: false, message: msg, error: errorDetail});
        } finally {
            setLoading(false);
        }
    };

    return (
        <form onSubmit={handleSubmit} style={{display: 'flex', flexDirection: 'column', gap: 10, width: '100%'}}>
            <label style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                Email*
                <input type="email" value={email} onChange={e => setEmail(e.target.value)} required style={{width: '100%', maxWidth: '100%'}} />
            </label>
            <label style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                First Name
                <input type="text" value={firstName} onChange={e => setFirstName(e.target.value)} style={{width: '100%', maxWidth: '100%'}} />
            </label>
            <label style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                Last Name
                <input type="text" value={lastName} onChange={e => setLastName(e.target.value)} style={{width: '100%', maxWidth: '100%'}} />
            </label>
            <label style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                Role
                <select
                    value={role}
                    onChange={e => setRole(e.target.value)}
                    style={{
                        width: '100%',
                        maxWidth: '100%',
                        border: '1px solid var(--border-main, #EDEDED)',
                        borderRadius: 4,
                        padding: '10.5px 38px 10.5px 14px',
                        fontSize: 16,
                        outline: 'none',
                        boxSizing: 'border-box',
                        marginTop: 0,
                        marginBottom: 0,
                        background: `#fff url('data:image/svg+xml;utf8,<svg fill="%23999" height="20" viewBox="0 0 24 24" width="20" xmlns="http://www.w3.org/2000/svg"><path d="M7 10l5 5 5-5z"/></svg>') no-repeat right 12px center/20px 20px`,
                        appearance: 'none',
                        WebkitAppearance: 'none',
                        MozAppearance: 'none',
                        backgroundColor: '#fff',
                        cursor: 'pointer',
                    }}
                >
                    <option value="admin">admin</option>
                </select>
            </label>
            <label style={{display: 'flex', flexDirection: 'column', gap: 4}}>
                Department
                <input type="text" value={department} onChange={e => setDepartment(e.target.value)} style={{width: '100%', maxWidth: '100%'}} />
            </label>
            <button className='btn' type="submit" disabled={loading}>{loading ? 'Sending...' : 'Invite Admin'}</button>
            {result && (
                <div style={{color: result.success ? 'green' : 'red', marginTop: 8}}>
                    {result.message}
                    {result.error && (
                        <div style={{marginTop: 4, fontSize: 13, color: '#b71c1c'}}>{result.error}</div>
                    )}
                </div>
            )}
        </form>
    );
};

export default AdminConfigPage;